const fields = {
  "Standards and Norms": [
    {
      name: "Iso Designation",
      title: "isoDesignation",
    },
    {
      name: "Standard",
      title: "standart",
    },
    {
      name: "Key Norms",
      title: "keyNorms",
    },
  ],
  Forming: [
    {
      name: "Machinability index (%)",
      title: "machinability",
    },
  ],
  "Mechanical properties": [
    {
      name: "Elongation (%)",
      title: "elongation",
    },
    {
      name: "Hardness (HB)",
      title: "hardnessHB",
    },
    {
      name: "Hardness (HRC)",
      title: "hardnessHRC",
    },
    {
      name: "Hardness (HV)",
      title: "hardnessHV",
    },
    {
      name: "Impact Toughness (Charpy)",
      title: "impactToughness",
    },
    {
      name: "Tensile Strengh (ksi)",
      title: "tensileStrengthKsi",
    },
    {
      name: "Tensile Strengh (MPa)",
      title: "tensileStrengthMPa",
    },
    {
      name: "Yield Strengh (ksi)",
      title: "yieldStrengthKsi",
    },
    {
      name: "Yield Strength (MPa)",
      title: "yieldStrengthMPa",
    },
    {
      name: "Young Modulus (GPa)",
      title: "youngModulus",
    },
  ],
  "Physical properties": [
    {
      name: "Electrical Conductivity (%IACS)",
      title: "electricalConductivityIACS",
    },
    {
      name: "Electrical Conductivity (mS/m)",
      title: "electricalConductivityMS",
    },
    {
      name: "Density (g/cm&#179;)",
      title: "density",
    },
    {
      name: "Thermal Conductivity (W/m/K at 20 to 200&#176;C)",
      title: "thermalConductivity",
    },
    {
      name: "Thermal Expansion Coefficient (10-6/K at 20 to 200&#176;C)",
      title: "thermalExpansionCoeff",
    },
    {
      name: "Magnetic Permeability",
      title: "magneticPermability",
    },
  ],
  "Surface properties": [
    {
      name: "Corrosion Resistance",
      title: "NACECorrosion",
    },
    {
      name: "Friction",
      title: "friction",
    },
  ],
  Other: [
    {
      name: "Other Comments",
      title: "otherComments",
    },
  ],
  "Forms and sizes": [
    {
      name: "Strips & Rolled products",
      title: "stripsAndRolledProducts",
      type: "dot",
    },
    {
      name: "&emsp;Thickness (mm)",
      title: "stripsThickness",
      type: "number",
    },
    {
      name: "&emsp;Width (mm)",
      title: "stripsWidth",
      type: "number",
      spaceUnder: true,
    },
    {
      name: "Wires",
      title: "wireForm",
      type: "dot",
    },
    {
      name: "Rods",
      title: "rodForm",
      type: "dot",
    },
    {
      name: "Bars",
      title: "barForm",
      type: "dot",
    },
    {
      name: "Tubes & Hollow Bars",
      title: "tubesAndHollowBars",
      type: "dot",
    },
    {
      name: "&emsp;Diameter of round forms (mm)",
      title: "tubesDiameter",
      type: "number",
      spaceUnder: true,
    },
    {
      name: "Special profiles",
      title: "specialProfiles",
      type: "dot",
    },
    {
      name: "&emsp;Indicative size (mm)",
      title: "specialProfilesIndicativeSize",
      type: "number",
    },
  ],
};

export default fields;
